require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-how-to-determine-the-value-of-an-e-commerce-business.json") })
        }
      }, "path---blog-how-to-determine-the-value-of-an-e-commerce-business");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-how-to-determine-the-value-of-an-e-commerce-business!./.cache/json/blog-how-to-determine-the-value-of-an-e-commerce-business.json
// module id = 459
// module chunks = 231608221292675